import { isNotNullOrUndefined } from '@vy/utils';
import type * as pdfjsLib from 'pdfjs-dist';
import { useEffect, useRef } from 'react';

const PDF_VIEWER_SCALE = 3;

type UsePdfRendererProps = {
  page: pdfjsLib.PDFPageProxy;
};

export const usePdfRenderer = ({ page }: UsePdfRendererProps): React.RefObject<HTMLCanvasElement> => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const renderingRef = useRef(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas?.getContext('2d');

    if (isNotNullOrUndefined(canvas) && isNotNullOrUndefined(context) && !renderingRef.current) {
      renderingRef.current = true;

      const viewport = page.getViewport({ scale: PDF_VIEWER_SCALE });
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      canvas.style.height = '100%';
      canvas.style.width = '100%';

      const renderContext = {
        canvasContext: context,
        viewport,
      };

      void page.render(renderContext).promise.finally(() => {
        renderingRef.current = false;
      });
    }
  }, [page]);

  return canvasRef;
};
